export default __webpack_public_path__ + "static/confirmation-ppq-modal-images-b0771cca7ba51261b8559a0296984b9f.png";